// Permisos por pagina de mantenimiento.
//
// El permiso sale de los accesos del usuario (accesos seeded en la tabla
// acceso, con codigo pagina.accion). Mientras la seguridad este desactivada
// (parametro SEGURIDAD_ACTIVA = 'N') o aun no se hayan cargado los accesos,
// todo se permite: es el comportamiento de siempre, para poder trabajar sin dar
// de alta los roles.
//
// La lista de paginas queda aqui para el menu y los botones; el permiso real lo
// resuelve useMantenimiento con los accesos del usuario.
const PERMISOS_POR_DEFECTO = {
    persona: { ver: true, editar: true },
    modelo: { ver: true, editar: true },
    periodo: { ver: true, editar: true },
    diaFeriado: { ver: true, editar: true },
    atencion: { ver: true, editar: true },
    diagnostico: { ver: true, editar: true },
    terapia: { ver: true, editar: true },
    terapiaPlan: { ver: true, editar: true },
    terapiaPeriodo: { ver: true, editar: true },
    terapiaPeriodoPago: { ver: true, editar: true },
    sesion: { ver: true, editar: true },
    participante: { ver: true, editar: true },
    conceptoCobro: { ver: true, editar: true },
    comprobante: { ver: true, editar: true },
    catalogo: { ver: true, editar: true },
    trabajador: { ver: true, editar: true },
    usuario: { ver: true, editar: true },
    rol: { ver: true, editar: true },
    autorizacion: { ver: true, editar: false },
    configuracion: { ver: true, editar: true },
    // La bitacora no se edita: solo se mira.
    bitacora: { ver: true, editar: false },
    // Las paginas que faltaban: las evaluaciones y los objetivos de los
    // participantes, el catalogo de objetivos, los descuentos y las ventanas
    // del terapeuta.
    evaluacion: { ver: true, editar: true },
    descuento: { ver: true, editar: true },
    sesionTerapeuta: { ver: true, editar: true },
    terapiaPlanTerapeuta: { ver: true, editar: true },
    articulo: { ver: true, editar: true },
    kardex: { ver: true, editar: true },
    cajachica: { ver: true, editar: true },
};
const getPermiso = (pagina) =>
    PERMISOS_POR_DEFECTO[pagina] ?? { ver: true, editar: true };

export const puedeVerPagina = (pagina) => getPermiso(pagina).ver;

export const puedeEditarPagina = (pagina) => getPermiso(pagina).editar;

// True si el usuario tiene el acceso "pagina.accion". Con la seguridad
// desactivada o sin accesos cargados, se concede.
export const tieneAcceso = (accesos, codigoAcceso) => {
    if (!accesos || accesos.length === 0) return true;

    return accesos.includes(codigoAcceso);
};

export const puedeAccederFichaIngreso = (usuario, roles = []) => {
    if (!usuario) return false;
    const u = usuario.toLowerCase();
    if (u === "admin") return true;
    const rolesNormalizados = (roles || []).map((r) => String(r).toLowerCase());
    const rolesPermitidos = ["administrador", "director", "secretaria", "monitoreo"];
    return rolesNormalizados.some((r) => rolesPermitidos.includes(r));
};

export const puedeAccederKardexYCaja = (usuario, roles = []) => {
    if (!usuario) return false;
    const u = usuario.toLowerCase();
    if (u === "admin") return true;
    const rolesNormalizados = (roles || []).map((r) => String(r).toLowerCase());
    const rolesPermitidos = ["administrador", "director", "secretaria", "secretario"];
    return rolesNormalizados.some((r) => rolesPermitidos.includes(r));
};

export default { puedeVerPagina, puedeEditarPagina, tieneAcceso, puedeAccederFichaIngreso, puedeAccederKardexYCaja };